<div class="page-header"
     [style.background-image]="background"
     [style.height]="height"
     [class.reverse-padding]="reverse"
     [class.reverse-padding-top]="reverseDir[0]"
     [class.reverse-padding-right]="reverseDir[1]"
     [class.reverse-padding-bottom]="reverseDir[2]"
     [class.reverse-padding-left]="reverseDir[3]"
     [style.margin-bottom]="margin"></div>
